import type { LDFlagSet } from 'launchdarkly-js-sdk-common';

import {
  FF_ANONYMOUS_USERS,
  FF_C4C_CHAT_NOTIFICATION_EXPERIMENT,
  FF_C4C_INC_VIDEO_CHAT,
  FF_DISABLE_CONSULTATION_BUTTONS,
  FF_ENABLE_AUTO_PROMOTION_CODE,
  FF_ENABLE_DISCOUNT_CODE,
  FF_ENABLE_FORM_QUICK_SUBMIT,
  FF_ENABLE_GOOGLE_PLACES,
  FF_ENABLE_IMMEDIATE_CONSULTS_PROMO_CODES,
  FF_ENABLE_SNOWPLOW,
  FF_ENABLE_TIMEZONE_WITH_PRECONSULT_DOB,
  FF_IMMEDIATE_D2D_CONSULTATION,
  FF_IMMEDIATE_NURSE_CONSULTATION,
  FF_IMMEDIATE_NURSE_CONSULTATION_VARIANTS,
  FF_MEDICAL_RECORDS_CONSENT_PAGE_V2,
  FF_MEDICARE_CHECKSUM,
  FF_PPP_TESTING,
  FF_ROUTE_PRESCREENING_PATIENT_TO_D2D,
} from '@/constants/featureFlags';

const ffDefaults: LDFlagSet = {
  [FF_ANONYMOUS_USERS]: false,
  [FF_C4C_CHAT_NOTIFICATION_EXPERIMENT]: false,
  [FF_C4C_INC_VIDEO_CHAT]: false,
  [FF_DISABLE_CONSULTATION_BUTTONS]: false,
  [FF_ENABLE_DISCOUNT_CODE]: false,
  [FF_ENABLE_FORM_QUICK_SUBMIT]: false,
  [FF_ENABLE_GOOGLE_PLACES]: false,
  [FF_ENABLE_IMMEDIATE_CONSULTS_PROMO_CODES]: false,
  [FF_ENABLE_SNOWPLOW]: false,
  [FF_ENABLE_TIMEZONE_WITH_PRECONSULT_DOB]: false,
  [FF_IMMEDIATE_NURSE_CONSULTATION]: false,
  [FF_IMMEDIATE_NURSE_CONSULTATION_VARIANTS]: 'control',
  [FF_MEDICARE_CHECKSUM]: false,
  [FF_PPP_TESTING]: false,
  [FF_ENABLE_AUTO_PROMOTION_CODE]: false,
  [FF_MEDICAL_RECORDS_CONSENT_PAGE_V2]: false,
  [FF_IMMEDIATE_D2D_CONSULTATION]: false,
  [FF_ROUTE_PRESCREENING_PATIENT_TO_D2D]: false,
};

export default ffDefaults;
